import { Form } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import type { FormItemProps } from "antd"
import React from "react"
import styles from "./JiraIssueField.module.scss"

export const JiraFormItem = ({
  fieldKey,
  className,
  label,
  fieldHint,
  required,
  formItemName,
  initialValue,
  children,
  rules = []
}: {
  fieldKey: string
  className?: string
  label?: React.ReactNode
  fieldHint?: string
  required?: boolean
  formItemName: string | (string | number)[]
  initialValue?: any
  children: React.ReactNode
  rules?: FormItemProps["rules"]
}) => {
  const { t } = useTranslation()
  const combinedRules = [
    {
      required,
      message: t("error.requiredField") || "Field is required"
    },
    ...rules
  ]

  return (
    <Form.Item
      key={fieldKey}
      className={className}
      label={label}
      extra={
        fieldHint ? <span className={styles.fieldHint}>{fieldHint}</span> : null
      }
      rules={combinedRules}
      name={formItemName}
      initialValue={initialValue}
    >
      {children}
    </Form.Item>
  )
}
